import { Feature } from '@/services/backstage/Feature';
import { ReadEmployee } from '@/services/gql/graphql.generated';
import { FC } from 'react';
import { ContractDetailsCard } from './contract/TeamMemberContractDetailsCard';
import { TeamMemberAvailabilityScheduleCard } from './schedule/TeamMemberAvailabilityScheduleCard';
import { PermissionsCard } from './TeamMemberPermissionsCard';

interface TeamMemberWorkRulesProps {
  employee: ReadEmployee;
  editSchedule?: boolean;
}

export const workRulesSectionId = 'workRulesSectionId';

export const TeamMemberWorkRules: FC<TeamMemberWorkRulesProps> = ({ employee, editSchedule }) => {
  return (
    <section id={workRulesSectionId} className="flex flex-col gap-4">
      <Feature name="roster">
        <TeamMemberAvailabilityScheduleCard employee={employee} enableEdit={editSchedule} />
      </Feature>
      <PermissionsCard employee={employee} />
      <ContractDetailsCard employee={employee} />
    </section>
  );
};
